import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./Components/pages/Dash";
import NotFoundPage from "./Components/pages/404";
import Login from "./Components/pages/Login";
import Question from "./Components/pages/Question";
import Lesson from "./Components/pages/Lesson";
import Comments from "./Components/pages/Comments";
import TicketsList from "./Components/pages/tickets";
import TicketMessage from "./Components/pages/ticketMessage";
import Gift from "./Components/pages/gift";
import Notice from "./Components/pages/notice";
import ArticlePage from "./Components/pages/ArticlePage";
import Evaluation from "./Components/pages/evaluation";
import QuestionsStatic from "./Components/pages/questionsStatic";
import TemplateManager from "./Components/pages/template";
import SlidersPage from "./Components/pages/Sliders";
import ReportsList from "./Components/pages/questionReports";
import HomeWork from "./Components/pages/homeWork";

function App() {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Dash" element={<Dashboard />} />
          <Route path="/Question" element={<Question />} />
          <Route path="/Lesson" element={<Lesson />} />
          <Route path="/Comments" element={<Comments />} />
          <Route path="/ArticlePage" element={<ArticlePage />} />
          <Route path="/gift" element={<Gift />} />
          <Route path="/tickets" element={<TicketsList />} />
          <Route path="/questionReport" element={<ReportsList />} />
          <Route path="/notice" element={<Notice />} />
          <Route path="/evaluation" element={<Evaluation />} />
          <Route path="/ticketMessage/:id" element={<TicketMessage />} />
          <Route path="/questionsStatic" element={<QuestionsStatic />} />
          <Route path="/template" element={<TemplateManager />} />
          <Route path="/slider" element={<SlidersPage />} />
          <Route path="/homeWork" element={<HomeWork />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  );
}

export default App;
